// layouts/catalogos/grabacion/editar-grabacion.js

import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";

import FormPage from "ui/FormPage";
import { PrimaryButton, OutlineButton } from "ui/Buttons";
import FormTextField from "ui/FormTextField";

import { getRecordType, updateRecordType } from "../services/grabacion";

function extractErrMessages(err) {
  const out = [];
  const d = err?.response?.data ?? err;
  const push = (m) => m && out.push(String(m));

  if (typeof d === "string") push(d);
  else if (Array.isArray(d))
    d.forEach((it) =>
      push(
        it?.message ||
          `${it?.instancePath || it?.path || ""} ${it?.message || ""}`.trim()
      )
    );
  else if (d?.errors && Array.isArray(d.errors))
    d.errors.forEach((it) =>
      push(
        it?.message ||
          `${it?.instancePath || it?.path || ""} ${it?.message || ""}`.trim()
      )
    );
  else if (d?.message) push(d.message);
  else push(err?.message || "Error desconocido");

  return out;
}

export default function EditarGrabacion() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const [name, setName] = useState("");
  const [createdAt, setCreatedAt] = useState("");

  useEffect(() => {
    let cancel = false;
    (async () => {
      setLoading(true);
      setErrors([]);
      try {
        const r = await getRecordType(id);
        if (cancel) return;
        setName(r?.name ?? r?.nombre ?? "");
        setCreatedAt(r?.created_at ?? r?.createdAt ?? "");
      } catch (e) {
        if (!cancel) setErrors(extractErrMessages(e));
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => {
      cancel = true;
    };
  }, [id]);

  const isValid = useMemo(() => !!name.trim(), [name]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) return;
    setSaving(true);
    setErrors([]);
    try {
      // 👇 SOLO NAME
      await updateRecordType(id, { name: name.trim() });
      navigate("/catalogos/grabacion", { replace: true });
    } catch (e2) {
      setErrors(extractErrMessages(e2));
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormPage
      title="Editar grabación"
      onBack={() => navigate("/catalogos/grabacion")}
      pageMaxWidth={1100}
      contentMaxWidth={900}
      actions={
        <>
          <PrimaryButton
            type="submit"
            form="form-grab"
            disabled={!isValid || saving || loading}
          >
            {saving ? "Guardando..." : "Guardar"}
          </PrimaryButton>
          <OutlineButton onClick={() => navigate("/catalogos/grabacion")}>
            Cancelar
          </OutlineButton>
        </>
      }
    >
      {errors.length > 0 && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errors.map((m, i) => (
            <div key={i}>{m}</div>
          ))}
        </Alert>
      )}

      <form id="form-grab" onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FormTextField
              label="Nombre*"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={loading}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormTextField
              label="Creado"
              value={createdAt}
              disabled
            />
          </Grid>
        </Grid>
      </form>
    </FormPage>
  );
}
